import { Box, styled, SxProps, Theme } from '@mui/material';
import BasePageFrame from '../base-components/base-page-frame';
import userState from '../../atoms/user-state';
import { useRecoilValue } from 'recoil';
import { useRef, useEffect } from 'react';

const VIEWPORT_HEIGHT = 'VIEWPORT_HEIGHT';
const REQUEST_VIEWPORT_HEIGHT = 'REQUEST_VIEWPORT_HEIGHT';
const RESIZE_IFRAME = 'RESIZE_IFRAME';

export const reloadIframe = () => {
	const iframe = document.querySelector('iframe[name="frame"]') as HTMLIFrameElement;
	if (iframe) {
		const currentSrc = iframe.src;
		iframe.src = '';
		iframe.src = currentSrc;
	}
};

const StyledIFrame = styled('iframe')(({ theme }) => ({
	borderStyle: 'none',
	width: '100%',
	height: '100%',
	overflowY: 'hidden',
	backgroundColor: 'transparent',
}));

const BackofficeIframe = ({ path }: { path: string }) => {
	const user = useRecoilValue(userState);
	const iframeRef = useRef<HTMLIFrameElement>(null);
	const boxRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const iframe = iframeRef.current;
		if (!iframe) return;

		const sendViewportResize = (cause: string): void => {
			if (iframe.contentWindow) {
				iframe.contentWindow.postMessage(
					{
						type: VIEWPORT_HEIGHT,
						innerHeight: window.innerHeight,
						scrollY: window.scrollY,
						cause: cause,
					},
					'*'
				);
			}
		};

		const handleResize = () => {
			sendViewportResize('window resize');
		};

		const handleMessage = (event: MessageEvent) => {
			if (event.data?.type === RESIZE_IFRAME) {
				if (boxRef.current) {
					boxRef.current.style.height = `${event.data.height}px`;
				}
			}
			if (event.data?.type === REQUEST_VIEWPORT_HEIGHT) {
				sendViewportResize('solicitud del iframe');
			}
		};

		window.addEventListener('resize', handleResize);
		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('resize', handleResize);
			window.removeEventListener('message', handleMessage);
		};
	}, []);

	const objectToSend = {
		token: user.token,
		cuit: user.cuit_external,
		id_external: user.id_external,
		phone: user.phone,
	};

	const encodedParam = btoa(JSON.stringify(objectToSend));

	return (
		<Box
			ref={boxRef}
			sx={{
				height: '100vh',
				minHeight: '110vh',
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<StyledIFrame
				ref={iframeRef}
				title='frame'
				name='frame'
				allow='clipboard-write'
				src={`${process.env.REACT_APP_BACKOFFICE_BASE_URL}${path}?token=${encodedParam}`}
			></StyledIFrame>
		</Box>
	);
};

export default function IframeWrapper({
	title,
	subtitle = '',
	transparent = true,
	path,
}: {
	id?: string;
	title?: string;
	subtitle?: string;
	transparent?: boolean;
	path: string;
	sx?: SxProps<Theme>;
}) {
	return (
		<BasePageFrame title={title} noTitle={!title} subtitle={subtitle} transparent={transparent}>
			<BackofficeIframe path={path} />
		</BasePageFrame>
	);
}
